module.exports = __webpack_public_path__ + "static/media/Mobile_DATA_ANALYTICS_DOS_DADOS_AOS_INSIGTHS.e4a4d6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/dataAnalytics/Mobile_DATA_ANALYTICS_DOS_DADOS_AOS_INSIGTHS.png
// module id = 57
// module chunks = 0